export default "__VITE_ASSET__BGn9rYa3__"